import "tailwindcss/tailwind.css";
import React, { useContext, createContext, useEffect } from "react";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { Hydrate } from "react-query/hydration";
import Modal from "react-modal";
import Navbar from "../components/nav/navbar";
import Head from "next/head";
import "../styles/global.css";
import { churchCustomStyles, eventCustomStyles } from "../styles/modalStyles";
import Footer from "../components/footer/footer";
import ChurchContent from "../components/churchPage/churchContent";
import EventContent from "../components/eventPage/eventContent";
import { SocketProvider } from "lib/socket";
import { useSessionStorage } from "hooks";

import "focus-visible";

Modal.setAppElement("#__next");

import { useRouter } from "next/router";

function MyApp({ Component, pageProps }) {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30 * 1000, // 30 seconds
          },
        },
      })
  );
  const router = useRouter();

  const prevPath = useSessionStorage("prevPath");

  useEffect(() => storePathValues, [router.asPath]);

  function storePathValues() {
    let storage = null;
    if (window) {
      storage = window.sessionStorage;
    }
    if (!storage) return;
    // Set the previous path as the value of the current path.
    const prevPath = storage.getItem("currentPath");
    storage.setItem("prevPath", prevPath);
    // Set the current path value by looking at the browser's location object.
    storage.setItem("currentPath", window.location.pathname);
  }

  return (
    <QueryClientProvider client={queryClient}>
      <SocketProvider>
        <Head>
          <title key="title">Virtuaalikirkko</title>
          <meta name="title" key="m-title" content="Virtuaalikirkko" />
          <meta
            name="description"
            key="description"
            content="Tervetuloa ev.-lut kirkkojen internetlähetyskanavaan!"
          />
          <meta
            property="og:url"
            key="og:url"
            content="https://www.virtuaalikirkko.fi"
          />
          <meta property="og:title" key="og:title" content="Virtuaalikirkko" />
          <meta
            property="og:description"
            key="og:description"
            content="Tervetuloa ev.-lut kirkkojen internetlähetyskanavaan!"
          />
          <link rel="canonical" href="https://www.virtuaalikirkko.fi/" />
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <link
            rel="apple-touch-icon"
            sizes="114x114"
            href="/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/favicon-16x16.png"
          />
          <link rel="manifest" href="/site.webmanifest" />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
          <meta name="msapplication-TileColor" content="#5bbad5" />
          <meta name="theme-color" content="#e6e6e6" />
        </Head>
        <Navbar />
        <Hydrate state={pageProps.dehydratedState}>
          <Component {...pageProps} />
        </Hydrate>
        <Footer />
        <Modal
          style={churchCustomStyles}
          isOpen={!!router.query.churchSlug}
          onRequestClose={() => (prevPath ? router.back() : router.push("/"))}
          contentLabel="Church modal"
          shouldCloseOnOverlayClick
          bodyOpenClassName={"ReactModal__Body--open"}
        >
          <ChurchContent slug={router.query.churchSlug} renderError={false} />
        </Modal>
        <Modal
          style={eventCustomStyles}
          isOpen={!!router.query.accountSlug && !!router.query.eventSlug}
          onRequestClose={() => (prevPath ? router.back() : router.push("/"))}
          contentLabel="Event modal"
          shouldCloseOnOverlayClick
          bodyOpenClassName={"ReactModal__Body--open"}
        >
          <EventContent
            slug={router.query.accountSlug}
            eventUrl={router.query.eventSlug}
            renderError={false}
          />
        </Modal>
        <ReactQueryDevtools initialIsOpen={false} />
      </SocketProvider>
    </QueryClientProvider>
  );
}

export default MyApp;
